import { createSlice } from '@reduxjs/toolkit'

import { RootState } from '../../../../store'

import { fetchAbsences } from './apiActions/fetchAbsences'
import { fetchCurrentUser } from './apiActions/fetchCurrentUser'
import { fetchPersonList } from './apiActions/fetchPersonList'
import { fetchWorkingHours } from './apiActions/fetchWorkingHours'
import { initialState } from './initialPersonState'
import { PersonState } from './IPerson'

export const { reducer: personReducer } = createSlice({
  name: 'person',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchPersonList.fulfilled, (state, action) => {
      state.list = action.payload
      return state
    })
    builder.addCase(fetchCurrentUser.fulfilled, (state, action) => {
      state.current = action.payload
      return state
    })
    builder.addCase(fetchWorkingHours.fulfilled, (state, action) => {
      state.hours = action.payload
      return state
    })
    builder.addCase(fetchAbsences.fulfilled, (state, action) => {
      state.absences = action.payload
      return state
    })
  },
})

export const personStateSelector = (state: RootState): PersonState =>
  state.personNew

export const personAbsencesSelector = (state: RootState) =>
  personStateSelector(state).absences || []
export const personCurrentSelector = (state: RootState) =>
  personStateSelector(state).current
export const personHoursSelector = (state: RootState) =>
  personStateSelector(state).hours || []
export const personListSelector = (state: RootState) =>
  personStateSelector(state).list

export default personReducer
